import { UrlRedirectsGridView } from '~/components/system/url-redirects';
import { PageContainer } from '~/components/page-container';

export function UrlRedirects() {
	return (
		<PageContainer>
			<UrlRedirectsGridView />
		</PageContainer>
	);
}
